import { useEffect, useRef } from "react";
import { useAppLoading } from "../../context/AppLoadingContext";

export function TrackedImage({ src, onLoad, onError, ...props }) {
  const { beginTask } = useAppLoading();
  const imageRef = useRef(null);
  const releaseRef = useRef(null);
  const releasedRef = useRef(false);

  useEffect(() => {
    if (!src) {
      return undefined;
    }

    releasedRef.current = false;
    const endTask = beginTask();

    releaseRef.current = () => {
      if (releasedRef.current) {
        return;
      }

      releasedRef.current = true;
      endTask();
    };

    const image = imageRef.current;
    if (image?.complete && image.naturalWidth > 0) {
      releaseRef.current();
    }

    return () => {
      releaseRef.current?.();
      releaseRef.current = null;
    };
  }, [beginTask, src]);

  return (
    <img
      ref={imageRef}
      src={src}
      {...props}
      onLoad={(event) => {
        onLoad?.(event);
        releaseRef.current?.();
      }}
      onError={(event) => {
        onError?.(event);
        releaseRef.current?.();
      }}
    />
  );
}
